import {
	TAKING_CAR_PURCHASE_SAVE_BOTH_BEGIN,
	TAKING_CAR_PURCHASE_SAVE_BOTH_SUCCESS,
	TAKING_CAR_PURCHASE_SAVE_BOTH_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function reducer(state, action) {
	switch (action.type) {
		case TAKING_CAR_PURCHASE_SAVE_BOTH_BEGIN:
			return {
				takingCarManagement: {
					...state.takingCarManagement,
					savePending: true,
					saveSuccess: null,
					saveError: null
				}
			}
		case TAKING_CAR_PURCHASE_SAVE_BOTH_SUCCESS:
			const possibleActionsArrayTcs = BFFAgent.Stock.TakingCarManagement.mapPossibleActionToOptions(action.data.tcs.possible_action)
			const possibleActionsArrayTcm = BFFAgent.Stock.TakingCarManagement.mapPossibleActionToOptions(action.data.tcm.possible_action)
			const takingCarManagement = {
				...state.takingCarManagement,
				savePending: false,
				saveError: null,
				saveSuccess: true,
			}
			takingCarManagement.saleStateUpdate = action.data.tcs
			takingCarManagement.sellPossibleActions = possibleActionsArrayTcs
			if (!takingCarManagement.buyStateUpdate)
				takingCarManagement.buyStateUpdate = {}
			takingCarManagement.buyStateUpdate.taking_car_sell = null
			takingCarManagement.buyStateUpdate = action.data.tcm
			takingCarManagement.buyPossibleActions = possibleActionsArrayTcm


			return {
				...state,
				takingCarManagement
			}
		case TAKING_CAR_PURCHASE_SAVE_BOTH_FAILURE:
			return {
				takingCarManagement: {
					...state.takingCarManagement,
					savePending: false,
					saveSuccess: false,
					saveError: action.data
				}
			}
		default:
			return state
	}
}
